import { graphql } from "@cappelendamm/crystallize-types/core/gql";
export const UpdateCustomer = graphql(`
  mutation UpdateCustomer($identifier: String!, $input: UpdateCustomerInput!) {
    updateCustomer(identifier: $identifier, input: $input) {
      __typename
      ... on Customer {
        identifier
      }
      ... on BasicError {
        errorName
        message
      }
    }
  }
`);
